import { useEffect, useState } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
const server_url = process.env.REACT_APP_API_URI;

const Productadd = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState('');
  const [contentName, setContentName] = useState('');
  const [contentDescription, setContentDescription] = useState('');
  const token = localStorage.getItem('loginToken');
  const [userData, setUserData] = useState(null);

  const getAllCategories = async () => {
    try {
      const url = `${server_url}/context/get-all-category`;
      const response = await axios.get(url);

      // Filter out "Movie", "Video Games", and "Television"
      const filteredCategories = response.data.data.filter(
        (category) =>
          category.title !== 'Movie' &&
          category.title !== 'Video Games' &&
          category.title !== 'Television',
      );

      setCategories(filteredCategories);
    } catch (err) {
      console.error('Error fetching categories:', err);
    }
  };

  useEffect(() => {
    getAllCategories();
  }, []);

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserData(decoded);
      } catch (error) {
        console.error('Invalid token:', error);
        setUserData(null);
      }
    } else {
      setUserData(null);
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !selectedCategoryId ||
      !contentName ||
      !contentDescription ||
      !userData?.id
    ) {
      alert('Please fill all fields.');
      return;
    }

    const formData = {
      contentName,
      userId: userData.id,
      contentDescription,
      catId: selectedCategoryId,
    };
    console.log(formData);

    try {
      await axios.post(`${server_url}/my-products/addProduct`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert('Product added successfully!');
      setSelectedCategoryId('');
      setContentName('');
      setContentDescription('');
    } catch (error) {
      console.error('Error adding product:', error);
      alert('Failed to add product.');
    }
  };

  return (
    <>
      <div className="min-h-[calc(100vh-300px)] max-w-screen-xl mx-auto mt-6 mb-4">
        <h1 className="text-4xl font-bold text-secondary text-center mb-6">
          Add Product
        </h1>
        <div className="lg:max-w-xl mx-4 md:mx-auto bg-gray-900 shadow-lg rounded-lg p-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Category Dropdown */}
            <div>
              <label className="block text-white font-medium">Category:</label>
              <select
                onChange={(e) => setSelectedCategoryId(e.target.value)}
                value={selectedCategoryId}
                className="w-full mt-1 p-2 border border-gray-700 rounded-lg 
                focus:outline-none focus:ring-2 focus:ring-secondary bg-gray-800 text-white"
              >
                <option value="">Select a category</option>
                {categories.map((category) => (
                  <option key={category.id} value={category._id}>
                    {category.title}
                  </option>
                ))}
              </select>
            </div>

            {/* Content Name */}
            <div>
              <label className="block text-white font-medium">
                Content Name:
              </label>
              <input
                type="text"
                value={contentName}
                onChange={(e) => setContentName(e.target.value)}
                placeholder="Enter content name"
                className="w-full mt-1 p-2 border border-gray-700 rounded-lg 
                focus:outline-none focus:ring-2 focus:ring-secondary bg-gray-800 text-white"
              />
            </div>

            {/* Content Description */}
            <div>
              <label className="block text-white font-medium">
                Content Description:
              </label>
              <textarea
                value={contentDescription}
                onChange={(e) => setContentDescription(e.target.value)}
                placeholder="Enter content description"
                className="w-full mt-1 p-2 border border-gray-700 rounded-lg 
                focus:outline-none focus:ring-2 focus:ring-secondary bg-gray-800
                 text-white h-28"
              ></textarea>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-secondary text-white py-2 rounded-lg 
              font-medium transition duration-200"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Productadd;
